import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Peso
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Weight {
    constructor (public weight = 0, public price = 0) {}

    public static convert (data: KeyValuePair): Weight {
        return new Weight(data.weight, data.price)
    }

    public serialize (): KeyValuePair {
        return {
            weight: this.weight,
            price: this.price,
        }
    }
}
